<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["NO"] }}
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["RS"] }}
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["U"] }}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MTA"]["PMT"] }}
                                            </template>
                                            <template v-else-if="header == 'PT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["PG"] }}
                                                <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TW'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["CBL"] }}
                                                <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["PA"] }}
                                                <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["BB"] }}
                                                <i @click="setSortTable('WBB')" :class="setSortLogo('WBB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["TO"] }}
                                                <i @click="setSortTable('TA')" class="sortlogo" :class="setSortLogo('TA')"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["CT"] }}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'OP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["OP"] }}
                                            </template>
                                            <template v-else-if="header == 'AT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["APPTS"] }}
                                                <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'IP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["IP"] }}
                                                <i @click="setSortTable('AIP')" :class="setSortLogo('AIP')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['PAP']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('PM.AGI')"
                                                  v-model="arr_FV['AGI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :cacheOptions="false"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="arr_FV['MB']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['RS']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_memberpromotionstatus"
                                            :placeholder="this.utilGetDDLanguage('PM.RS')"
                                            v-model="arr_FV['RS']"
                                            :max-height="200" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MTA']['PMT']}} :</span>
                                <CInput size="sm" v-model="arr_FV['PC']"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["OP"]}} :</span>
                                <CInput size="sm" :value="arr_FV['OP']" @change="v => arr_FV['OP'] = v"></CInput>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>

        <div class="container-fluid">
            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="100%">{{this.getLanguage['MTA']['APS']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if=" arry_psl.length != 0" @click="bool_showSummary = !bool_showSummary" class='kema-eft'>
                            <td style="width:25%">{{this.getLanguage['MTA']['GT']}}</td>
                            <td style="width:25%" class="tableCtnRight">{{ formatNumber(decimal_gt, 2, "USD") }}</td>
                        </tr>
                        </tbody>
                        <thead v-if="bool_showSummary">
                            <tr>
                                <th style="width:25%">{{this.getLanguage['MTA']['TMC']}}</th>
                                <th style="width:25%">{{this.getLanguage['MTA']['TAPA']}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="bool_showSummary">
                        <td colspan="100%" v-if=" arry_psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_psl">
                            <td>{{ data.TMC }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.TAPA, 2, data.CS) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']['PAPL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["RS"] }}
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["U"] }}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MTA"]["PMT"] }}
                                    </template>
                                    <template v-else-if="header == 'PT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PG"] }}
                                        <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TW'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["CBL"] }}
                                        <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PA"] }}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["BB"] }}
                                        <i @click="setSortTable('WBB')" :class="setSortLogo('WBB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["TO"] }}
                                        <i @click="setSortTable('TA')" class="sortlogo" :class="setSortLogo('TA')"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["CT"] }}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'OP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["OP"] }}
                                    </template>
                                    <template v-else-if="header == 'AT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["APPTS"] }}
                                        <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["IP"] }}
                                        <i @click="setSortTable('AIP')" :class="setSortLogo('AIP')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue' style="min-height: 100px;">
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["RS"] }}
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["U"] }}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MTA"]["PMT"] }}
                                    </template>
                                    <template v-else-if="header == 'PT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PG"] }}
                                        <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TW'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["CBL"] }}
                                        <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PA"] }}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["BB"] }}
                                        <i @click="setSortTable('WBB')" :class="setSortLogo('WBB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["TO"] }}
                                        <i @click="setSortTable('TA')" class="sortlogo" :class="setSortLogo('TA')"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["CT"] }}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'OP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["OP"] }}
                                    </template>
                                    <template v-else-if="header == 'AT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["APPTS"] }}
                                        <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["IP"] }}
                                        <i @click="setSortTable('AIP')" :class="setSortLogo('AIP')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_PromotionReportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_PromotionReportList" :class="data.MS == 1? 'blacklist-row': ''">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'RS'">
                                    <span class="grid-line">
                                        {{ renderStatus(data.RS) }}
                                        <span v-if="(data.PG == 8 || data.PG == 18) && getUserInfo.AT !== 0">
                                        </span>
                                        <span class="custom_tooltip" v-else-if="checkModuleAccess('DCP', 'P', constAccessType.delete) && checkCanCancelPromotionMain(data,constAccessType.edit) && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="cancelPromotion(data,index)">
                                            <i class="cil-x-circle"></i>
                                            <span class="tooltiptext">{{getLanguage["GL"]["CANCEL"]}}</span>
                                        </span>
                                        <span class="custom_tooltip" v-else-if="checkModuleAccess('DCP', 'P', constAccessType.delete) && checkCanCancelPromotionMain(data,constAccessType.edit) && (isSENS == 1 && data.AAGI != curAGI)">
                                            <i class="cil-x-circle"></i>
                                            <span class="tooltiptext">{{getLanguage["GL"]["CANCEL"]}}</span>
                                        </span>
                                    </span>
                                    <span class="grid-line rejectReason" v-if="data.RS==3">{{ renderRejectReason(data.RR) }}</span>
                                </template>
                                <template v-else-if="header == 'U'">
                                    <span class="grid-line" v-if="((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AAGI,data.MI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon"/>
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span class="grid-line" v-else-if="(isSENS == 1 && data.AAGI != curAGI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'PC'">
                                    {{ data.PC }}
                                </template>
                                <template v-else-if="header == 'PT'">
                                    <span class="grid-line">{{ renderPromotionGroup(data.PG) }}</span>
                                </template>
                                <template v-else-if="header == 'TW'">
                                    {{ formatNumber(data.CBL, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'BA'">
                                    {{ formatNumber(data.BA, 2, data.CS) }}
                                    <div class="custom_tooltip">
                                        <i class="fa fa-question-circle"></i>
                                        <span class="tooltiptext2 promotion-amount-tooltip">
                                            <div class="total-promo"><span class="tooltip-label">{{ getLanguage["PM"]["TBA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.TBA, 2, data.CS) }}</span></div>
                                            <div v-if="data.DA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["DA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.DA, 2, data.CS) }}</span></div>
                                            <div v-if="data.BA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["PA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.BA, 2, data.CS) }}</span></div>
                                            <div v-if="data.FBA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["CF"] }} :</span><span class="tooltip-val">{{ formatNumber(data.FBA, 2, data.CS) }}</span></div>
                                        </span>
                                    </div>
                                </template>
                                <template v-else-if="header == 'BB'">
                                    <span class="grid-line">
                                        <span v-if="data.BBB > 0">{{ getLanguage["PM"]["WBB"] }} : </span>
                                        {{ formatNumber(data.WBB, 2, data.CS) }}
                                    </span>
                                    <span class="grid-line" v-if="data.BBB > 0">{{ getLanguage["PM"]["BBB"] }} : {{ formatNumber(data.BBB, 2, data.CS) }}</span>
                                </template>
                                <template v-else-if="header == 'TA'">
                                    {{ formatNumber(data.ATA, 2, data.CS) }} / {{ formatNumber(data.WTA, 2, data.CS) }}
                                    <div v-if="data.FWTA > 0">{{ getLanguage["PM"]["CF"] }} : {{ formatNumber(data.FWTA, 2, data.CS) }}</div>
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    {{ formatDate(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'OP'">
                                    {{ data.AT }}
                                </template>
                                <template v-else-if="header == 'AT'">
                                    {{ formatDate(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'IP'">
                                    {{ data.AIP }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constPromoGroup, constPromotionStatus, constRejectReasonP, constAccessType, loadingFullScreen  } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable
        },

        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,
                bool_showSearchBar: true,
                arry_psl:[],
                arr_FV: {
                    "MB": null,
                    "DR": {
                        startDate: this.getTodayDate(),
                        endDate: this.getTodayEndDate()
                    },
                    "RS": 2,
                    "PC": "",
                    "AGI": null,
                    "OP": ""
                },
                arr_PromotionReportList: [],
                dd_memberpromotionstatus: [],
                dd_agentgroup: [],
                constAccessType: constAccessType,
                ddMemberList: [],
                defaultReportHeaders: ['NO', 'RS', 'U', 'PC', 'PT', 'TW', 'BA', 'BB', 'TA', 'CTS','OP', 'AT', 'IP'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            DateTimeChange(type, event){
                if(type=="SD"){
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if(dateObj != "Invalid Date" && event != ""){
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if(event != ""){
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    }else{
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if(type=="ED"){
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if(dateObj != "Invalid Date" && event != ""){
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if(event != ""){
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    }else{
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            CheckingMember(agi,mi){ 
                let routeData = this.$router.resolve({ path:'/M/ML/CheckingMember', query:{ agi: agi, i: mi}});
                window.open(routeData.href, '_blank');
            },
            renderPromotionGroup(int_promoGroup) {
                var promoGroup = "";
                for (var i = 0; i < constPromoGroup.length; i++) {
                    for (var j = 0; j < constPromoGroup[i].children.length; j++) {
                        if (constPromoGroup[i].children[j].id == int_promoGroup) {
                            promoGroup = constPromoGroup[i].children[j].label;
                            break;
                        }
                    }
                }
                return promoGroup;
            },
            checkCanCancelPromotionMain(data, type) {
                 if(this.checkModuleAccess('DCP', 'P', constAccessType.delete) && data.RS == 2){
                     return true;
                 }else{
                     return this.checkCanCancelPromotion(data, type, true);
                 }
                
            },
            checkCanCancelPromotion(data, type ,checkAccess) {
                let canSurrender = false;

                if (data.STP > 0) {
                    let usedAmountPerc = data.UBA * 100.0 / data.DA;
                    canSurrender = (100 - usedAmountPerc) <= data.STP;
                }
                else if(data.STP == 0 && data.UBA > 0 && !this.checkModuleAccess('DCP', 'P', constAccessType.delete)){
                    return false;
                }

                if(checkAccess){
                     return (data.CC || canSurrender) && data.RS == 2 && this.checkModuleAccess('PAP', 'P', type);
                }else{
                     return (data.CC || canSurrender) && data.RS == 2;
                }
               
            },

            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getPromotionReportList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getPromotionReportList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getPromotionReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;
                this.dd_memberpromotionstatus = [{ // key1 = CTNT
                    id: "1",
                    label: this.getLanguage['PM']['AC1'] //pending
                },
                {
                    id: "2",
                    label: this.getLanguage['PM']['AC2'] //AP
                },
                {
                    id: "3",
                    label: this.getLanguage['PM']['AC3'] //RJ
                },
                {
                    id: "4",
                    label: this.getLanguage['PM']['AC4'] // CP
                },
                {
                    id: "5",
                    label: this.getLanguage['PM']['AC5'] //C
                },
                {
                    id: "6",
                    label: this.getLanguage['PM']['AC6'] //CCL
                },
                {
                    id: "7",
                    label: this.getLanguage['PM']['AC7'] //SRD
                },
                {
                    id: "8",
                    label: this.getLanguage['PM']['AC8'] //EP
                },
                {
                    id: "9",
                    label: this.getLanguage['PM']['AC9'] // CF
                }
                ];
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            //var cloneParentGroup = that.deepClone(d.dropdownlist);

                            ////// list filter only push in child group, do not include own group
                            //if (cloneParentGroup != null && cloneParentGroup.length > 0) {
                            //    that.dd_agentgroup = [];
                            //    for (var i = 0; i < cloneParentGroup.length; i++) {
                            //        for (var j = 0; j < cloneParentGroup[i].children.length; j++) {
                            //            that.dd_agentgroup.push(cloneParentGroup[i].children[j]);
                            //        }
                            //    }
                            //}
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.arr_FV["AGI"]) {
                        agi = this.arr_FV["AGI"].split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            getPromotionReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        "f.MI=" + (this.arr_FV["MB"] == null ? "" : this.arr_FV["MB"]) +
                        "&f.RS_in=" + (this.arr_FV["RS"] == null ? "" : this.arr_FV["RS"]) +
                        "&f.PC=" + (this.arr_FV["PC"] == null ? "" : this.arr_FV["PC"]) +
                        "&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]) +
                        "&f.OP=" + (this.arr_FV["OP"] == null ? "" : this.arr_FV["OP"])
                    );

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.PTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.PTS_to=" + cts_to;
                    }
                }
                this.getDataApi(`/api/mpromo/pap?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_PromotionReportList = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
                this.getDataApi(`/api/mpromo/ap/total?${path}`,
                    function (data) {
                        that.setActivePromoSummaryList(data);
                    });
            },
            setActivePromoSummaryList(data) {
                this.arry_psl = data;
                this.decimal_gt = 0;
                if (this.arry_psl.length != 0) {
                    for (var i = 0; i < this.arry_psl.length; i++) {
                        this.decimal_gt += this.arry_psl[i].GT;
                    }
                }
            },
            renderStatus(statusCode) {
                return this.getLanguage['PM']['AC' + statusCode];
            },
            renderRejectReason(rejectReason) {
                const found = constRejectReasonP.some(el => el.id === rejectReason);

                if (found) {
                    for (var d of constRejectReasonP) {
                        if (d.id == rejectReason) {
                            rejectReason = d.label;
                        }
                    }
                }

                return rejectReason;
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            cancelPromotion(d, index) {
                var title_Text = null;
                if(!this.checkCanCancelPromotion(d,0,false)){
                    title_Text=this.getLanguage["PM"]["NECP"];
                }
                //console.log(title_Text);
                if (d.PG == 5 || d.PG == 15 || d.PG == 6 || d.PG == 16)
                {
                    this.$fire({
                        title: title_Text!=null ? title_Text :this.getLanguage["PM"]["CCERC"],
                        html: title_Text!=null ?this.getLanguage["PM"]["CCE"]:"",
                        width: '30em',
                        showDenyButton: true,
                        showCancelButton: true,
                        showConfirmButton:false,
                        //confirmButtonText: this.getLanguage["PM"]["CONLY"],
                        denyButtonText: this.getLanguage["PM"]["CNS"],
                        cancelButtonText: this.getLanguage["GL"]["CANCEL"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }                      
                    }).then((result) => {
                        let isCancel = false;
                        let DP = false;

                        //// cancel this promotion
                        if (result.isConfirmed) {
                            isCancel = true;
                            DP = false;
                        }
                        //// cancel and stop future recurring
                        else if (result.isDenied) {
                            isCancel = true;
                            DP = true;
                        }

                        if (isCancel) {
                            this.bool_fullLoading = true;
                            this.bool_fullScreen = true;
                            var that = this;

                            let actionCode = d.CC ? 6 : 7;

                            var dt = {
                                I: d.I,
                                UTS: d.UTS,
                                AC: actionCode,
                                DP: DP,
                                PSRT: "::[PM][PCT]::",   //this.getLanguage["PM"]["PCT"],
                                PSRM: "::[PM][PCM]::",   //this.getLanguage["PM"]["PCM"]
                                IIPGR: 0,
                            };

                            this.postDataApi(`/api/mpromo/cp`, dt,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    that.bool_fullScreen = false;
                                    if (!s) {
                                        if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 6017) {
                                            that.$fire({
                                                title: that.getLanguage["PM"]["CCE"],
                                                html: that.getLanguage["PM"]["CIIPGR"],
                                                width: '30em',
                                                showCancelButton: true,
                                                confirmButtonText: that.getLanguage["GL"]["YES"],
                                                cancelButtonText: that.getLanguage["CNO"]["NO"],
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            }).then((result) => {
                                                if (result.value == true) {
                                                    that.bool_fullLoading = true;
                                                    dt.IIPGR = 1;
                                                    that.postDataApi(`/api/mpromo/cp`, dt,
                                                        function (d, s) {
                                                            that.bool_fullLoading = false;
                                                            that.bool_fullScreen = false;
                                                            that.getPromotionReportList();
                                                        });
                                                }
                                            });
                                        }
                                        else if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 6018) {
                                            that.$fire({
                                                title: 'Cancel Failed',
                                                html: d.ERR.map(o => {
                                                    const result = o.CL.map(c => {
                                                        const provider = that.getLanguage["GP"][c];
                                                        return provider ? `${provider}: ${o.ED}` : null;
                                                    }).filter(e => e !== null);
                                                    return result;
                                                }).join('<br>'),
                                                width: '30em',
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            });
                                        }
                                        else if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 1017) {
                                            that.$fire({
                                                title: 'Cancel Failed',
                                                html: 'Promotion already finished.',
                                                width: '30em',
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            });
                                        }
                                        else if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 1018) {
                                            that.$fire({
                                                title: 'Cancel Failed',
                                                html: 'Promotion already closed.',
                                                width: '30em',
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            });
                                        }
                                        else {
                                            that.bool_fullLoading = false;
                                            that.bool_fullScreen = false;
                                            that.getPromotionReportList();
                                        }
                                    }
                                    else {
                                        that.bool_fullLoading = false;
                                        that.bool_fullScreen = false;
                                        that.getPromotionReportList();
                                    }
                                });
                        }
                    });
                }
                else {
                    this.$fire({
                        title: title_Text!=null ? title_Text :this.getLanguage["PM"]["CCE"],
                        html: title_Text!=null ?this.getLanguage["PM"]["CCE"]:"",
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            this.bool_fullScreen = true;
                            var that = this;

                            let actionCode = d.CC ? 6 : 7;

                            var dt = {
                                I: d.I,
                                UTS: d.UTS,
                                AC: actionCode,
                                DP: true,
                                PSRT: "::[PM][PCT]::",   //this.getLanguage["PM"]["PCT"],
                                PSRM: "::[PM][PCM]::",   //this.getLanguage["PM"]["PCM"]
                                IIPGR: 0,
                            };

                            this.postDataApi(`/api/mpromo/cp`, dt,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    that.bool_fullScreen = false;
                                    if (!s) {
                                        if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 6017) {
                                            that.$fire({
                                                title: that.getLanguage["PM"]["CCE"],
                                                html: that.getLanguage["PM"]["CIIPGR"],
                                                width: '30em',
                                                showCancelButton: true,
                                                confirmButtonText: that.getLanguage["GL"]["YES"],
                                                cancelButtonText: that.getLanguage["CNO"]["NO"],
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            }).then((result) => {
                                                if (result.value == true) {
                                                    that.bool_fullLoading = true;
                                                    dt.IIPGR = 1;
                                                    that.postDataApi(`/api/mpromo/cp`, dt,
                                                        function (d, s) {
                                                            that.bool_fullLoading = false;
                                                            that.bool_fullScreen = false;
                                                            that.getPromotionReportList();
                                                        });
                                                }
                                            });
                                        }
                                        else if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 6018) {
                                            that.$fire({
                                                title: 'Cancel Failed',
                                                html: d.ERR.map(o => {
                                                    const result = o.CL.map(c => {
                                                        const provider = that.getLanguage["GP"][c];
                                                        return provider ? `${provider}: ${o.ED}` : null;
                                                    }).filter(e => e !== null);
                                                    return result;
                                                }).join('<br>'),
                                                width: '30em',
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            });
                                        }
                                        else if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 1017) {
                                            that.$fire({
                                                title: 'Cancel Failed',
                                                html: 'Promotion already finished.',
                                                width: '30em',
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            });
                                        }
                                        else if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 1018) {
                                            that.$fire({
                                                title: 'Cancel Failed',
                                                html: 'Promotion already closed.',
                                                width: '30em',
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            });
                                        }
                                        else {
                                            that.bool_fullLoading = false;
                                            that.bool_fullScreen = false;
                                            that.getPromotionReportList();
                                        }
                                    }
                                    else {
                                        that.bool_fullLoading = false;
                                        that.bool_fullScreen = false;
                                        that.getPromotionReportList();
                                    }
                                });
                        }
                    });
                }
            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderClassName(header, data) {
                if(header == 'TW' || header == 'BA' || header == 'BB' || header == 'TA') {
                    return "tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        created() {
            this.reportHeaders = null;
            if (this.$route.path == '/P/PAP') {
                this.$parent.showSubMenu = 'P';
                this.$parent.showActiveMenu = 'P.PAP';
            } else if (this.$route.path == '/M/PAP') {
                this.$parent.showSubMenu = 'M';
                this.$parent.showActiveMenu = 'M.PAP';
            }
            this.$parent.showSubSubMenu = '';
            this.getDropdownList();
            this.getPromotionReportList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        watch: {
            getLanguage() {
                this.getPromotionReportList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/ActivePromotion`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/ActivePromotion/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/ActivePromotion.vue